import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";

import {
  saveTrainingRequest,
  saveTrainingSuccess,
  saveTrainingFailure,
  getTrainingsRequest,
  getTrainingsSuccess,
  getTrainingsFailure,
  updateTrainingStatusRequest,
  updateTrainingStatusSuccess,
  updateTrainingStatusFailure,
  getTrainingActivityRequest,
  getTrainingActivitySuccess,
  getTrainingActivityFailure,
} from "./trainingSlice";

function* handleSaveTraining(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/training/saveTraining`,
      action.payload,
    );

    if (response.data.success) {
      yield put(saveTrainingSuccess(response.data));

      toast.success(response.data.message || "Training saved successfully");

      yield put(
        getTrainingsRequest({
          page: 1,
          limit: 10,
        }),
      );
    } else {
      yield put(saveTrainingFailure(response.data.message));

      toast.error(response.data.message || "Failed to save training");
    }
  } catch (error) {
    yield put(saveTrainingFailure(error.message));

    toast.error(error.response?.data?.message || "Failed to save training");
  }
}

function* fetchTrainings(action) {
  try {
    const payload = action.payload || {};

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/training/getTrainings`,
      {
        params: payload,
      },
    );

    yield put(getTrainingsSuccess(response.data));
  } catch (error) {
    yield put(getTrainingsFailure(error.message));

    toast.error("Failed to fetch trainings");
  }
}

function* updateTrainingStatusSaga(action) {
  try {
    const { id, status } = action.payload;

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/training/updateTrainingStatus/${id}`,
      { status },
    );

    if (response.data.success) {
      yield put(updateTrainingStatusSuccess(response.data.data));
      toast.success(response.data.message || "Status updated");

      yield put(getTrainingsRequest({ page: 1, limit: 10 }));
    } else {
      yield put(updateTrainingStatusFailure(response.data.message));
      toast.error(response.data.message || "Failed to update status");
    }
  } catch (error) {
    yield put(updateTrainingStatusFailure(error.message));
    toast.error(error.response?.data?.message || "Failed to update status");
  }
}

function* getTrainingActivitySaga(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/training/getTrainingActivity`,
      {
        id: action.payload.id,
      },
    );

    if (response.data.success) {
      yield put(getTrainingActivitySuccess(response.data));
    } else {
      yield put(getTrainingActivityFailure(response.data.message));
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(getTrainingActivityFailure(error.message));
    toast.error(
      error.response?.data?.message || "Failed to fetch training activity",
    );
  }
}

export function* trainingSaga() {
  yield takeLatest(saveTrainingRequest.type, handleSaveTraining);

  yield takeLatest(getTrainingsRequest.type, fetchTrainings);
  yield takeLatest(updateTrainingStatusRequest.type, updateTrainingStatusSaga);
  yield takeLatest(getTrainingActivityRequest.type, getTrainingActivitySaga);
}
